<div class="pdf-text-preview"
     [style.fontSize.px]="fontSize"
     [style.fontWeight]="fontWeight"
     [style.fontStyle]="fontStyle"
     [style.textAlign]="textAlign"
     [style.color]="color">
  {{ displayText }}
</div>
